import * as React from "react"
import { useState } from "react"
import { Checkbox } from "antd"
import { MultiSelectItem } from "../MultiSelect"
import { HighlightedText } from "../../HighlightedText/HighlightedText"
import { classNames } from "../../../../utils/classNames"
import { CaretDownFill, CaretRightFill } from "react-bootstrap-icons"

type Props = {
    disableOnly: boolean
    isChecked: boolean
    isIndeterminate: boolean
    item: MultiSelectItem
    searchLabel: string
    labelOnly?: boolean
    hasCollapsibleItems: boolean
    isCollapsible: boolean
    isExpanded: boolean
    level: number
    onToggleExpand: (id: string) => void
    onClick: (id: string, item: MultiSelectItem) => void
    onOnlyClick: (id: string, item: MultiSelectItem) => void
}

export const MultiSelectListItem = (props: Props) => {
    const [hovered, setHovered] = useState(false)

    const onOnlyClicked = (e: React.MouseEvent<HTMLButtonElement>) => {
        e.stopPropagation()
        props.onOnlyClick(props.item.id, props.item)
    }

    const showOnly = !props.disableOnly && hovered

    if (props.labelOnly) {
        const label = props.item.renderCustomLabel?.(props.item, props.searchLabel) ?? props.item.label
        return <div className={classes.labelOnly}>{label}</div>
    }

    return (
        <button
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
            type="button"
            className={classNames(classes.button, props.item.className)}
            onClick={() => {
                props.onClick(props.item.id, props.item)
            }}>
            <div
                className={classNames(classes.wrap, showOnly ? "pr-[25%]" : "pr-2")}
                style={{
                    paddingLeft: `${props.level * 10}px`,
                }}>
                {props.hasCollapsibleItems ? (
                    <button
                        className={classNames(classes.collapseIconWrap, !props.isCollapsible && "invisible")}
                        onClick={e => {
                            e.stopPropagation()
                            props.onToggleExpand(props.item.id)
                        }}>
                        {props.isExpanded ? (
                            <CaretDownFill className={classes.collapseIcon} />
                        ) : (
                            <CaretRightFill className={classes.collapseIcon} />
                        )}
                    </button>
                ) : null}
                <Checkbox
                    className="mr-2"
                    tabIndex={-1}
                    checked={props.isChecked}
                    indeterminate={props.isIndeterminate}
                />
                <div className={classes.labelWrap}>
                    {!props.item.renderCustomLabel ? (
                        <HighlightedText
                            highlight={props.searchLabel}
                            classNameHighlight={classes.searchHighlight}
                            text={props.item.label}
                        />
                    ) : (
                        props.item.renderCustomLabel(props.item, props.searchLabel)
                    )}
                </div>
                {props.item.suffix ? <div className={classes.suffix}>{props.item.suffix}</div> : null}
                {showOnly && (
                    <button type="button" onClick={onOnlyClicked} className={classes.onlyBtn}>
                        Only
                    </button>
                )}
            </div>
        </button>
    )
}

const classes = {
    button: "align-left relative w-full cursor-pointer truncate bg-white h-[2.1rem] pl-3 hover:bg-[#E0F6E1] hover:bg-opacity-50 focus:outline-none",
    onlyBtn:
        "text-[12px] absolute inset-y-0 right-0 w-1/3 cursor-pointer bg-transparent pr-5 text-right opacity-30 hover:text-primary-color hover:opacity-100",
    labelOnly: "mt-1.5 pl-3 text-[13px] text-black/50",
    searchHighlight: "bg-yellow-300",
    wrap: "flex items-center w-full",
    labelWrap: "flex-1 truncate",
    collapsibleItemWrap: "flex items-center relative",
    collapseIconWrap: "cursor-pointer px-1.5 mr-0.5 bg-transparent group z-[10] block -ml-2 py-1 align-left",
    collapseIcon: "w-[9px] h-auto -mt-px text-black/75 group-hover:text-primary-color",
    suffix: "ml-1.5",
}
